export default __webpack_public_path__ + "static/present-b168ab7cea14dcb0064b3a1ea43293aa.svg";